import { render, staticRenderFns } from "./item.vue?vue&type=template&id=14fa108f&scoped=true&"
import script from "./item.js?vue&type=script&lang=js&"
export * from "./item.js?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=14fa108f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa108f",
  null
  
)

export default component.exports